export var surface_core__ask__entitites__askentities__MoveIn;
(function (surface_core__ask__entitites__askentities__MoveIn) {
    let type;
    (function (type) {
        type["MOVE_IN"] = "MoveIn";
    })(type = surface_core__ask__entitites__askentities__MoveIn.type || (surface_core__ask__entitites__askentities__MoveIn.type = {}));
})(surface_core__ask__entitites__askentities__MoveIn || (surface_core__ask__entitites__askentities__MoveIn = {}));
